var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("check")]),
              _vm._v(" Aprobar permiso\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-container",
                {
                  staticClass: "p-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "texto-aprobar" }, [
                          _c("b", [_vm._v("Número:")]),
                          _vm._v(" " + _vm._s(_vm.permiso.numero))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "texto-aprobar" }, [
                          _c("b", [_vm._v("Funcionario:")]),
                          _vm._v(" " + _vm._s(_vm.permiso.nombres))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "texto-aprobar" }, [
                          _c("b", [_vm._v("Tipo de papeleta:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.permiso.tipo_permiso) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 8
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Lugar de atencion:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.permiso.lugar_atencion) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Lugar de comisión :")]),
                              _vm._v(" " + _vm._s(_vm.permiso.lugar))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87 ||
                      _vm.permiso.id_tipo_permiso == 104 ||
                      _vm.permiso.id_tipo_permiso == 96
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Motivo:")]),
                              _vm._v(" " + _vm._s(_vm.permiso.motivo))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 90
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Tipo de baja:")]),
                              _vm._v(" " + _vm._s(_vm.permiso.motivo))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == "61"
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Fecha de nacimiento:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.fecha_nac_muerte) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == "61"
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Hora de nacimiento:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.hora_nac_muerte) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == "6"
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Fecha de fallecimiento:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.fecha_nac_muerte) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == "6"
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Hora de fallecimiento:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.hora_nac_muerte) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == "12"
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [_vm._v("Fecha de matrimonio:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.permiso.fecha_nac_muerte)
                                      .format("DD-MM-YY")
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 44
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "texto-aprobar" }, [
                              _c("b", [
                                _vm._v("Condición o estado crítico de salud :")
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.permiso.motivo) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "subtitulo-aprobar" }, [
                          _c("b", [_vm._v("Detalles de papeleta.")])
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.id_tipo_permiso == 87 ||
                          _vm.permiso.id_tipo_permiso == 104 ||
                          _vm.permiso.id_tipo_permiso == 96 ||
                          _vm.permiso.id_tipo_permiso == 88 ||
                          (_vm.permiso.id_tipo_permiso >= 37 &&
                            _vm.permiso.id_tipo_permiso <= 43)
                            ? _c(
                                "v-data-table",
                                {
                                  staticClass:
                                    "tabla-comprimida-light elevation-1",
                                  attrs: {
                                    items: _vm.permiso_detalles2,
                                    "hide-actions": "",
                                    headers: _vm.headers_horas
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.fecha_desde
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.fecha_retorno
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.hora_desde)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.hora_hasta)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.horas_permiso
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1594454660
                                  )
                                },
                                [_vm._v("\n              >\n              ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.id_tipo_permiso == 14 ||
                          _vm.permiso.id_tipo_permiso == 105 ||
                          (_vm.permiso.id_tipo_permiso >= 98 &&
                            _vm.permiso.id_tipo_permiso <= 101) ||
                          _vm.permiso.id_tipo_permiso == 89 ||
                          _vm.permiso.id_tipo_permiso == 18
                            ? _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias_decimales
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_desde
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_retorno
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.nro_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  737503760
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.id_tipo_permiso == 6 ||
                          _vm.permiso.id_tipo_permiso == 44 ||
                          _vm.permiso.id_tipo_permiso == 95 ||
                          _vm.permiso.id_tipo_permiso == 61 ||
                          _vm.permiso.id_tipo_permiso == 12 ||
                          _vm.permiso.id_tipo_permiso == 90
                            ? _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_desde
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_retorno
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.nro_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  418140492
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 94
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_registro_asistencias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_desde
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_retorno
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1910998633
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.id_tipo_permiso == "24"
                            ? _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_desde
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          props.item.rango_horario == 1
                                            ? _c("td", [_vm._v("Solo mañana")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          props.item.rango_horario == 2
                                            ? _c("td", [_vm._v("Solo tarde")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          props.item.rango_horario == 0
                                            ? _c("td", [_vm._v("Todo el día")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.total_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2345257647
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  _vm.permiso.id_tipo_permiso == 96
                    ? _c("span", { staticClass: "subtitulo-aprobar" }, [
                        _c("b", [_vm._v("Detalles compensacion")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  _vm.permiso.id_tipo_permiso == 96
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_compensacion,
                                  "hide-actions": "",
                                  headers: _vm.headers2
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_desde
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_hasta
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.diferencia_horas
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  486249175
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { staticClass: "pa-2" },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _vm.permiso.id_tipo_permiso == 88 ||
                        _vm.permiso.id_tipo_permiso == 96
                          ? _c("span", { staticClass: "subtitulo-aprobar" }, [
                              _c("b", [
                                _vm._v(
                                  "Total horas: " +
                                    _vm._s(_vm.total_horas_acomuladas)
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("span", { staticClass: "subtitulo-aprobar" }, [
                      _c("b", [_vm._v("Seguimiento de la papeleta")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "tabla-comprimida-light elevation-1",
                            attrs: {
                              headers: _vm.headers_seg_detalle,
                              items: _vm.detalle_seguimiento
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm
                                                .$moment(props.item._created_at)
                                                .format("DD/MM/YYYY")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.estado) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              props.item.usuario
                                                ? props.item.usuario
                                                : ""
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("close")]),
                  _vm._v("\n        Cancelar\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.apruebaRechazaPermiso(_vm.permiso, 7)
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("check")]),
                  _vm._v("\n        Aprobar\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-795cc321", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795cc321","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/AprobarPermisoOficialPorHoras.vue
// module id = null
// module chunks = 